import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z'
      fill='white'
      stroke='#B7B7B7'
    />
    <path
      d='M13.594 9.37575C13.474 9.37575 13.354 9.42586 13.2621 9.52507C13.0793 9.7245 13.0793 10.0487 13.2621 10.2481L17.6177 14.9998L13.2621 19.7514C13.0793 19.9508 13.0793 20.275 13.2621 20.4744C13.4449 20.6739 13.7421 20.6739 13.9249 20.4744L18.6124 15.3608C18.7952 15.1614 18.7952 14.8371 18.6124 14.6377L13.9249 9.52405C13.833 9.42382 13.713 9.37473 13.593 9.37473L13.594 9.37575Z'
      fill='#0D0D0D'
    />
  </svg>
)
